export default {
  BOOKING_REQUEST:  "booking/BOOKING_REQUEST",
  BOOKING_RESPONSE: "booking/BOOKING_RESPONSE",
  SUMMARY_REQUEST:"booking/SUMMARY_REQUEST",
  SUMMARY_RESPONSE:"booking/SUMMARY_RESPONSE",
  ANCILLARY_REQUEST: "booking/ANCILLARY_REQUEST",
  ANCILLARY_RESPONSE: "booking/ANCILLARY_RESPONSE",
  BOOKING_WITH_ALLSEGMENTS_RESPONSE: "booking/BOOKING_WITH_ALLSEGMENTS_RESPONSE",
}